import React from "react";

const PlatformNoticeModal = ({ title, message, onClose }) => {
  if (!title && !message) return null;

  const paragraphs = message
    ? message.split(/\n\n+/).filter((p) => p.trim())
    : [];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[60] px-4 py-6">
      <div
        className="bg-white rounded-2xl shadow-xl w-full max-w-lg max-h-[90vh] flex flex-col overflow-hidden"
        role="dialog"
        aria-modal="true"
        aria-labelledby="platform-notice-title"
      >
        <div className="flex items-start justify-between bg-[#005A9C] px-5 py-4 text-white shrink-0">
          <div className="flex items-start gap-3 pr-4">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white/20">
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h2
              id="platform-notice-title"
              className="text-base sm:text-lg font-semibold leading-snug"
            >
              {title}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 rounded-full p-1 text-white/90 hover:bg-white/20 hover:text-white transition-colors"
            aria-label="Close notice"
          >
            <svg
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="overflow-y-auto px-5 py-5 text-sm sm:text-base text-gray-700 leading-relaxed">
          {paragraphs.length > 0 ? (
            paragraphs.map((paragraph, index) => (
              <p
                key={index}
                className={index > 0 ? "mt-4" : ""}
              >
                {paragraph}
              </p>
            ))
          ) : (
            <p>{message}</p>
          )}
        </div>

        <div className="border-t border-gray-100 px-5 py-4 shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:w-auto sm:min-w-[160px] bg-[#003478] text-white font-medium px-6 py-2.5 rounded-lg hover:bg-[#002a5c] transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlatformNoticeModal;
